"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _findIllus = _interopRequireDefault(require("../assets/images/find-illus.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CreateCommunityCard({
  createCommunityCardActions
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#F3F6FF",
    borderRadius: 4,
    display: "flex",
    gap: 3,
    padding: 3,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    height: 60
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: "100%",
    src: _findIllus.default
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, null, t('commons.communities.search.create_community'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0
  }, createCommunityCardActions));
}
var _default = exports.default = CreateCommunityCard;